/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddCreatorFormWithLink } from '../models/AddCreatorFormWithLink';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AddCreatorRestControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static addCreatorViaLink({
        requestBody,
    }: {
        requestBody: AddCreatorFormWithLink,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/add',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
